import 'script-loader!waypoints/lib/noframework.waypoints.min.js'
import 'script-loader!waypoints/lib/shortcuts/inview.js'

const Animation = () => {
  const handlers = document.querySelectorAll('.js-animate')
  const waypoints = []

  if (!handlers || !handlers.length) return

  ;[...handlers].forEach((element) => {
    waypoints.push(new window.Waypoint.Inview({
      element,
      offset: 'bottom-in-view',
      enter: function () { this.element.classList.add('active') }
    }))
  })
}

export default Animation



// WEBPACK FOOTER //
// ./src/js/modules/Animation.js